// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bairun-container .el-dialog__wrapper .btn-tool-balancrange .el-form-item__content{\n    margin-left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
